<template>
  <!-- 售后列表头部信息 -->
  <div class="re_header_con">
    <div class="header_left">
      <!-- <img src="@/assets/order/icon_order1@2x.png" alt="" class="header_icon" /> -->
      <div class="left_id font12 font_weight400 colo087 line_height_24">
        单号：{{ item.id }}
      </div>
    </div>
    <div class="header_left mr_top">
      <div class="right_right">
        <!-- <img
          src="@/assets/order/icon_refund_money@2x.png"
          alt=""
          class="right_icon"
        /> -->
        <span
          class="font12 font_weight500 colo087 line_height_17 re_font left_id"
          >{{ item.afterSaleType | afterSaleTypeFilter }}</span
        >
        <div class="line_r"></div>
      </div>
      <div class="right_font font12 font_weight500 colo087 line_height_17">
        {{ item.status | statusFilter(item.afterSaleType) }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  filters: {
    afterSaleTypeFilter(type) {
      switch (type) {
        case 0:
          return "仅退款";
        case 1:
          return "退货退款";
        case 2:
          return "换货";
        default:
          return "";
      }
    },
    statusFilter(status, afterSaleType) {
      if (
        status === -32 ||
        status === -31 ||
        status === -30 ||
        status === -21
      ) {
        return "退款失败";
      }
      if (status === 34 || status === 35) {
        return "退款成功";
      }
      if (status === -1) {
        return "撤销售后";
      }
      if (status === 1) {
        return "客服审核中";
      }
      if (status === 31) {
        return "待商品寄回";
      }
      if (status === 32) {
        return "待商家收货";
      }
      if (status === 21) {
        return "店主审核中";
      }
      if (status === 33) {
        // 仅退款 (afterSaleType 为 0) 归属到客服审核中，其他归属到待商家收货
        return afterSaleType === 0 ? "客服审核中" : "待商家收货";
      }
      return "申请售后";
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>
.re_header_con {
  background: #fff;
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
  .header_left {
    display: flex;
    .header_icon {
      width: 24px;
      height: 24px;
    }
    .left_id {
      margin-left: 4px;
    }
  }
  .re_font {
    vertical-align: middle;
  }
  .right_icon {
    width: 16px;
    height: 16px;
    vertical-align: middle;
  }
  .right_right {
    font-size: 0;
    display: flex;
    margin-right: 8px;
  }
  .mr_top {
    margin-top: 4px;
  }
  .right_font {
    color: #d91818;
  }
  .line_r {
    width: 1px;
    height: 10px;
    background: rgba(0, 0, 0, 0.38);
    border-radius: 1px;
    margin-left: 8px;
    margin-top: 2px;
  }
}
</style>
